// extracted by mini-css-extract-plugin
module.exports = {"title":"UploadVideosComponent_title_tHZT2","subtext":"UploadVideosComponent_subtext_cGgbB","warning":"UploadVideosComponent_warning_PniHH"};